import CKEditor from 'src/components/editor'

const MainPage = props => {
  return <CKEditor />
}

export default MainPage
